import React from 'react'
import { Alert } from 'react-bootstrap';

const ErrorMessageComponent = () => {
  return (
    <div><Alert variant="danger">Error loading data</Alert></div>
  )
}

export default ErrorMessageComponent;